export default __webpack_public_path__ + "static/media/workouttimes@3x.62ada0c2.jpg";